module.exports = __webpack_public_path__ + "static/media/globe-white.2ea0ab49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/globe-white.svg
// module id = 1545
// module chunks = 0